module.exports = __webpack_public_path__ + "static/media/ArrowUp.73c7e7f8.svg";